/**
 * Type of throttle.
 * tag: 1612
 * @readonly
 * @enum {number} (int)
 */
export enum ThrottleType {
  /** Inbound Rate */
  InboundRate = 0,
  /** Outstanding Requests */
  OutstandingRequests = 1,
}
